import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';

const FeaturedSection = ({ onOpenBuilder }) => {
  return (
    <section className="py-20 bg-[#e8f4fc]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://images.pexels.com/photos/2895295/pexels-photo-2895295.jpeg?auto=compress&cs=tinysrgb&w=600"
                alt="Kaaba"
                className="w-full h-64 object-cover rounded-lg shadow-lg"
              />
              <img
                src="https://images.pexels.com/photos/3890524/pexels-photo-3890524.jpeg?auto=compress&cs=tinysrgb&w=600"
                alt="Masjid Nabawi"
                className="w-full h-64 object-cover rounded-lg shadow-lg mt-12"
              />
            </div>
            {/* Highlight Card */}
            <div className="absolute bottom-8 left-8 bg-[#d4af37] text-black p-4 rounded-lg shadow-lg">
              <p className="font-bold text-lg">Umrah Only</p>
              <p className="text-sm">No Flights - Pure Pilgrim Focus</p>
            </div>
          </div>

          {/* Right Content */}
          <div>
            <span className="text-[#d4af37] font-medium tracking-wider">WHY ZAMZAM UMRAH BUILDER</span>
            <h2 
              className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              Build Your Perfect Umrah Journey
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Unlike other travel agencies, we focus exclusively on Umrah services. No flight 
              bookings, no distractions - just pure dedication to making your pilgrimage perfect. 
              Our innovative builder lets you customize every aspect of your journey.
            </p>

            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <div>
                  <span className="font-semibold text-gray-800">Custom Hotel Selection</span>
                  <p className="text-sm text-gray-600">Choose from 50+ hotels in Makkah and Madinah</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <div>
                  <span className="font-semibold text-gray-800">Flexible Duration</span>
                  <p className="text-sm text-gray-600">7 to 21 nights - you decide how long</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <div>
                  <span className="font-semibold text-gray-800">Ground Transport Included</span>
                  <p className="text-sm text-gray-600">Airport transfers and inter-city transport</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <Check className="w-4 h-4 text-white" />
                </div>
                <div>
                  <span className="font-semibold text-gray-800">Instant Pricing</span>
                  <p className="text-sm text-gray-600">See your package cost in real-time as you build</p>
                </div>
              </li>
            </ul>

            <div className="flex gap-4">
              <Button
                onClick={onOpenBuilder}
                className="bg-[#d4af37] text-black hover:bg-[#c4a030] font-semibold px-6"
              >
                START BUILDING NOW
              </Button>
              <Button
                variant="ghost"
                className="text-gray-700 hover:bg-gray-200 font-semibold"
              >
                VIEW PACKAGES
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
